<template>
    <div style="text-align: center">
        <div style="display: inline-block; background-color: #e55700; border-radius: 8px;">
            <div class="my-1 mx-2">
                <v-icon class="white--text">fas fa-info-circle</v-icon>
                <strong class="white--text">
                    {{mensagem}}
                </strong>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    name: 'CampoVazioMensagem',
    props:{
        mensagem:{
            type: String,
            default: null
        }
    }
}
</script>
